// @core/api/endpoints/signature/update_party.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PartyResponse,
  UpdatePartyRequest,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Update a signing party
 * Partially updates a party (use update_mask). Typical mutations: notification channel, allowed methods, sign_order, external contact details. Status transitions go through dedicated RPCs (see framework-ddw).
 */
export async function UpdateParty(
  party_id: string,
  data: UpdatePartyRequest,
  options?: RequestOptions
): Promise<PartyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/parties/:party_id`;
  requestPath = requestPath.replace(':party_id', encodeURIComponent(party_id));
  const requestOptions = options;
  return client.patch<PartyResponse>(requestPath, data, requestOptions);
}
